import Kicker from "components/Kicker"
import ArrowButton from "components/buttons/ArrowButton"
import BoxIMG from "images/illustrations/BigClosedBox.svg"
import CargoIMG from "images/illustrations/LongCargoBox.svg"
import TapeIMG from "images/illustrations/Tape.svg"
import ConstantMarquee from "library/ConstantMarquee"
import { fmobile, fresponsive, ftablet } from "library/fullyResponsive"
import useMedia from "library/useMedia"
import styled, { css } from "styled-components"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function CTA() {
	const mobile = useMedia(false, false, false, true)

	return (
		<Wrapper>
			<Background>
				<Kicker barcodes="double" variant="long">
					Let&apos;s get going
				</Kicker>
				<Title>
					Ready to bring
					<Marquee timing={37}>
						<MarqueeContent>
							Real-Time Data
							<Circle />
							Top Vendors
							<Circle />
							Quality Products
							<Circle />
							Powerful Controls
							<Circle />
							Seamless Shipping
							<Circle />
						</MarqueeContent>
					</Marquee>
					to a single store?
				</Title>
				<Bottom>
					<Text>
						Get up and running in days, not months, with Response’s fast
						onboarding process and one-click integrations.
					</Text>
					<StyledArrowButton type="calendly">Book A Demo</StyledArrowButton>
				</Bottom>
			</Background>
			<Cargo data-speed="0.95" />
			<Box data-speed="0.95" />
			<Tape data-speed="0.95" />
		</Wrapper>
	)
}

const Wrapper = styled.section`
	${fresponsive(css`
		padding: 97px 40px 196px;
		position: relative;
		display: grid;
		place-items: center;
	`)}

	${fmobile(css`
		padding: 78px 16px 53px;
		display: block;
	`)}
`

const Background = styled.div`
	position: relative;
	z-index: 4;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: linear-gradient(
		258deg,
		rgb(255 255 255 / 40%) 0%,
		rgb(255 255 255 / 20%) 100%
	);
	border: 1px solid ${colors.grey1};

	${fresponsive(css`
		width: 1014px;
		border-radius: 20px;
		backdrop-filter: blur(6px);
		padding: 35px 0;
	`)}

	${ftablet(css`
		width: 944px;
	`)}

	${fmobile(css`
		width: 345px;
		height: 560px;
		padding: 40px 14px 15px;
	`)}
`

const Bottom = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;

	${fresponsive(css`
		padding: 0 50px;
	`)}

	${fmobile(css`
		flex-direction: column;
		gap: 68px;
		padding: 0;
	`)}
`

const Title = styled.div`
	${textStyles.h2}
	${fresponsive(css`
		display: grid;
		place-items: center;
		gap: 28px;
		margin-top: 25px;
		position: relative;
		z-index: 3;
		margin-bottom: 90px;
	`)}

  ${fmobile(css`
		${textStyles.h4};
		gap: 0;
		margin-top: 35px;
		margin-bottom: 35px;
		text-align: center;
		width: 100%;
		display: flex;
		flex-direction: column;
	`)}
`

const Marquee = styled(ConstantMarquee)`
	${fresponsive(css`
		width: 835px;
		left: unset;
		translate: unset;
		height: 150px;
		border-radius: 20px;
		border: 1px solid ${colors.blue3};
		background: ${colors.transBlue1};
		overflow: clip;
	`)}

	${fmobile(css`
		width: 100%;
		height: 73px;
		border-radius: 10px;
		margin: 10px 0 15px;
	`)}
`

const MarqueeContent = styled.div`
	${fresponsive(css`
		display: flex;
		align-items: center;
		color: ${colors.blue3};
		height: 150px;
	`)}

	${fmobile(css`
		height: 73px;
	`)}
`

const Circle = styled.div`
	${fresponsive(css`
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: ${colors.blue3};
		margin: 20px;
	`)}

	${fmobile(css`
		width: 10px;
		height: 10px;
	`)}
`

const Text = styled.p`
	${textStyles.p1}
	color: ${colors.grey3};

	${fresponsive(css`
		width: 371px;
	`)}

	${fmobile(css`
		${textStyles.p2}
		width: 274px;
		text-align: center;
	`)}
`

const IllustrationBase = css`
	${fresponsive(css`
		position: absolute;
		z-index: 2;
	`)}

	${fmobile(css`
		display: none;
	`)}
`

const Tape = styled.img.attrs({ src: TapeIMG, alt: "" })`
	${fresponsive(css`
		${IllustrationBase};
		scale: 1 -1;
		rotate: 115deg;
		transform: scaleX(-1);
		bottom: -150px;
		width: 348px;
	`)}

	${ftablet(css`
		bottom: -165px;
	`)}
`

const Cargo = styled.img.attrs({ src: CargoIMG, alt: "" })`
	${fresponsive(css`
		${IllustrationBase};
		transform: scaleX(-1);
		top: 33px;
		left: 190px;
		width: 363px;
	`)}

	${ftablet(css`
		left: -1px;
	`)}
`

const Box = styled.img.attrs({ src: BoxIMG, alt: "" })`
	${fresponsive(css`
		${IllustrationBase};
		top: 40px;
		right: 190px;
		width: 274px;
	`)}

	${ftablet(css`
		right: -5px;
		top: 43px;
	`)}
`

const StyledArrowButton = styled(ArrowButton)`
	${fmobile(css`
		width: 100%;
	`)}
`
